import React from 'react';
import { Link } from 'react-router-dom';
import { appSubDir } from '../../configs/app';
import './ShippingServiceBanner.scss';

const ShippingServiceBanner: React.FC = () => {
    return (
        <div className="shipping-service-banner">
            <span className="banner-text">Looking for Shipping Service</span>
            <Link to={appSubDir + "create-booking"} className="banner-btn">
                Click Here <span className="chevron">&raquo;</span>
            </Link>
        </div>
    );
};

export default ShippingServiceBanner;

